export default "__VITE_ASSET__BGoKiB3G__"